export const axiosGetNotifications = async (axiosPrivate, apiUrl, id, controller, isLoading, setResponse) => {
    try {
        const response = await axiosPrivate.get(apiUrl + `?id=${id}`,
            {
                signal: controller.signal
            });
        isLoading && setResponse(response.data)
    } catch (err) {
        // navigate('/auth', {state: {from: location}, replace: true})
        // logout();
        console.error(err);
    }
}